import React from 'react';
export function CompanyInfoSection() {
  return <div className="text-center space-y-3" data-id="element-1605">
      <h2 className="text-2xl md:text-3xl font-bold text-navy" data-id="element-1606">
        Peak Machine Sales (Peak EDM, Inc)
      </h2>
      <div className="text-gray-700" data-id="element-1607">
        <a href="https://www.google.com/maps/place/Peak+Machine+Sales/@42.4983841,-83.5194866,17z/" target="_blank" rel="noopener noreferrer" className="text-orange hover:underline block" data-id="element-1608">
          28221 Beck Road A-2
        </a>
        <a href="https://www.google.com/maps/place/Peak+Machine+Sales/@42.4983841,-83.5194866,17z/" target="_blank" rel="noopener noreferrer" className="text-orange hover:underline block" data-id="element-1609">
          Wixom, MI 48393
        </a>
      </div>
      <p className="text-gray-700" data-id="element-1610">
        <strong data-id="element-1611">Phone:</strong>{' '}
        <a href="tel:2483800871" className="text-orange hover:underline font-bold" data-id="element-1612">
          (248) 380-0871
        </a>
      </p>
    </div>;
}